
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15.71 17.467"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_36399","data-name":"Group 36399","transform":"translate(-423.813 -375.267)"}},[_c('path',{attrs:{"id":"Path_27674","data-name":"Path 27674","d":"M439.234 382.92a2.164 2.164 0 00-.8-.8l-11.374-6.566a2.168 2.168 0 00-3.25 1.877v13.13a2.167 2.167 0 003.25 1.881l11.371-6.565a2.167 2.167 0 00.8-2.959zm-1.548 1.659l-11.371 6.566a.687.687 0 01-1-.581v-13.131a.667.667 0 01.669-.667.661.661 0 01.331.089l11.374 6.566a.667.667 0 010 1.158z","fill":"#5a677d"}})])])
          )
        }
      }
    